import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/main';

export default function Main() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
